import type { TagInventoryFolderKind } from '@axilon-apps/domains-ontology-ui-state'

/** Query param holding the folder trail below the Providers root. */
export const TAGS_TRAIL_QUERY_PARAM = 'trail'

/** Query param holding the opened tag's row key. */
export const TAGS_SELECTED_QUERY_PARAM = 'selected'

/** Query param holding the page cursors walked past the first page of a folder. */
export const TAGS_PAGES_QUERY_PARAM = 'pages'

export interface FolderTrailEntry {
  kind: TagInventoryFolderKind
  id: string
  label: string
}

const KINDS: readonly string[] = ['provider', 'folder', 'udt']

export function encodeFolderTrail(trail: readonly FolderTrailEntry[]): string {
  return JSON.stringify(trail.map((entry) => [entry.kind, entry.id, entry.label]))
}

/** Malformed or tampered values decode to an empty trail (the Providers root). */
export function decodeFolderTrail(raw: string | null): FolderTrailEntry[] {
  if (!raw) return []
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    const trail: FolderTrailEntry[] = []
    for (const item of parsed) {
      if (!Array.isArray(item) || item.length !== 3) return []
      const [kind, id, label] = item as unknown[]
      if (
        typeof kind !== 'string' ||
        !KINDS.includes(kind) ||
        typeof id !== 'string' ||
        id === '' ||
        typeof label !== 'string'
      ) {
        return []
      }
      trail.push({ kind: kind as TagInventoryFolderKind, id, label })
    }
    return trail
  } catch {
    return []
  }
}

export function encodePageTokens(tokens: readonly string[]): string {
  const walked = tokens.filter((token) => token !== '')
  return walked.length > 0 ? JSON.stringify(walked) : ''
}

export function decodePageTokens(raw: string | null): string[] {
  if (!raw) return []
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed) || !parsed.every((t) => typeof t === 'string' && t !== '')) {
      return []
    }
    return parsed as string[]
  } catch {
    return []
  }
}
